import React, { useState } from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Bar } from "react-chartjs-2";
import ChartTable from "../chart-table";

// Static region list
const REGION_LIST = [
  { label: "North", value: "NORTH" },
  { label: "South", value: "SOUTH" },
  { label: "East", value: "EAST" },
  { label: "West", value: "WEST" },
];

const DaysToDispatchEngine = ({ data }) => {
  const [selectedRegion, setSelectedRegion] = useState(REGION_LIST[0].value);

  const regionData = data[selectedRegion] || [];

  const chartData = {
    labels: regionData.map((item) => item.state),
    datasets: [
      {
        label: "Min Days",
        data: regionData.map((item) => item.minDays),
        backgroundColor: "#1e88e5",
        barThickness: 20,
      },

      {
        label: "Max Days",
        data: regionData.map((item) => item.maxDays),
        backgroundColor: "#f57c00",
        barThickness: 20,
      },
      {
        label: "Avg Days",
        data: regionData.map((item) => item.avgDays),
        backgroundColor: "#009688",
        barThickness: 20,
      },
    ],
  };

  const chartOptions = {
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      tooltip: {
        enabled: true,
      },

      datalabels: {
        color: "#ffffff",
        anchor: "center",
        align: "center",
        font: {
          weight: "bold",
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // Remove vertical grid lines
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "#e0e0e0",
        },
      },
    },
  };

  const headers = ["", ...regionData.map((item) => item.state)];

  const rows = [
    ["Min days to Dispatch", ...regionData.map((item) => item.minDays)],
    ["Max days to Dispatch", ...regionData.map((item) => item.maxDays)],
    ["Avg days to Dispatch", ...regionData.map((item) => item.avgDays)],
  ];

  return (
    <Box>
      {/* Dropdown */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel>Select Region</InputLabel>
          <Select
            value={selectedRegion}
            onChange={(e) => setSelectedRegion(e.target.value)}
            label="Select Region"
          >
            {REGION_LIST.map((region) => (
              <MenuItem key={region.value} value={region.value}>
                {region.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {/* Chart + Table */}
      {regionData.length === 0 ? (
        <Typography sx={{ textAlign: "center", mt: 5 }}>
          No Data Available
        </Typography>
      ) : (
        <>
          <Bar data={chartData} options={chartOptions} />
          <Box mt={4}>
            <ChartTable headers={headers} rows={rows} />
          </Box>
        </>
      )}
    </Box>
  );
};

export default DaysToDispatchEngine;
